<template>
    <div>
        <transition name="slide-right-panel">
            <div class="side-panel right-sidebar shw-rside" style="min-width: 40%;" v-if="show">
                <div class="rpanel-title font-medium">
                    {{ comparisonItemName }} <span @click="closeComparisonItemPanel"><i
                    class="icon mdi mdi-close right-side-toggle"></i></span>
                </div>
                <div class="custom-scroll" style="display: block; height: 100vh; overflow: scroll">
                    <div>
                        <table class="table" style="margin-bottom: 10vh;">
                            <thead style="visibility: collapse;">
                                <th style="width: 50%;"></th>
                                <th style="width: 50%;"></th>
                            </thead>

                            <tbody>
                                <tr class="comparison-line" style="height: 100vh;">
                                    <td style="border-right: 1px solid #f5f5f5;padding:12px;">
                                        <div v-if="item1">
                                            <div>
                                                <div>
                                                    <span class="item-condition-label"
                                                          v-if="item1.cleanliness">{{ item1.cleanliness }}</span>
                                                    <span class="item-condition-label"
                                                          v-if="item1.damage">{{ item1.damage }}</span>
                                                    <span class="item-condition-label"
                                                          v-if="item1.functioning">{{ item1.functioning }}</span>
                                                </div>

                                                <div class="flow-root"></div>

                                                <div>
                                                    <p class="mt-1 mb-0 item-comments">{{ item1.comments }}
                                                        <span class="item-recommendation">
                                                            {{ item1.recommendation }}
                                                        </span>
                                                    </p>
                                                </div>
                                            </div>

                                            <div class="flow-root"></div>

                                            <div class="checklist-item-photos">
                                                <div v-for="photo in item1.photos"
                                                     class="checklist-item-photo-container-small">
                                                    <div class="relative">
                                                        <div>
                                                            <PinchScrollZoom
                                                                ref="zoomer"
                                                                :width="275"
                                                                :height="275"
                                                                min-scale="1"
                                                                max-scale="15"
                                                                scale="1"
                                                                :within="true">
                                                                <img class="checklist-item-photo-small" :src="photo.url"/>
                                                            </PinchScrollZoom>

                                                            <i v-if="isCopiedPhoto(photo)"
                                                               class="copied-photo mdi mdi-content-copy"></i>
                                                        </div>

                                                        <a :href="photo.url" class="absolute bottom-0 left-0" target="_blank">
                                                            <icon-download
                                                                class="w-6 h-6 text-black text-opacity-50 bg-white bg-opacity-50 rounded-tr-md"></icon-download>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>

                                    <td style="padding:12px;">
                                        <div v-if="item2">
                                            <div>
                                                <div>
                                                    <span class="item-condition-label" v-if="item2.cleanliness">{{ item2.cleanliness }}</span>
                                                    <span class="item-condition-label"
                                                          v-if="item2.damage">{{ item2.damage }}</span>
                                                    <span class="item-condition-label" v-if="item2.functioning">{{ item2.functioning }}</span>
                                                </div>

                                                <p class="mt-1 mb-0 item-comments">
                                                    {{ item2.comments }}
                                                    <span class="item-recommendation">
                                                        {{ item2.recommendation }}
                                                    </span>
                                                </p>
                                            </div>

                                            <div class="flow-root"></div>

                                            <div class="checklist-item-photos">
                                                <div v-for="photo in item2.photos"
                                                     class="checklist-item-photo-container-small">
                                                    <div class="relative">
                                                        <div>
                                                            <PinchScrollZoom
                                                                ref="zoomer"
                                                                :width="275"
                                                                :height="275"
                                                                min-scale="1"
                                                                max-scale="15"
                                                                scale="1"
                                                                :within="true">
                                                                <img class="checklist-item-photo-small" :src="photo.url"/>
                                                            </PinchScrollZoom>
                                                            <i v-if="isCopiedPhoto(photo)"
                                                               class="copied-photo mdi mdi-content-copy"></i>
                                                        </div>

                                                        <a :href="photo.url" class="absolute bottom-0 left-0" target="_blank">
                                                            <icon-download
                                                                class="w-6 h-6 text-black text-opacity-50 bg-white bg-opacity-50 rounded-tr-md"></icon-download>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import PinchScrollZoom, { PinchScrollZoomEmitData } from "@coddicat/vue-pinch-scroll-zoom";

export default {

    props: ["show", "comparisonItem"],

    components: {PinchScrollZoom},

    data () {
        return {
            item1: null,
            item2: null
        };
    },

    computed: {
        comparisonItemName () {

            if (this.item1) {
                return this.item1.item;
            }

            if (this.item2) {
                return this.item2.item;
            }

            return "";
        }
    },

    watch: {
        comparisonItem () {
            if (this.comparisonItem != null) {
                this.item1 = this.comparisonItem[0];
                this.item2 = this.comparisonItem[1];
                this.loadPhotos();
            } else {
                this.item1 = null;
                this.item2 = null;
            }
        }
    },

    methods: {
        comparisonItemClasses (item) {
            let diffClasses = "label label-light-info comparison-item-diff";

            if (item["diff_condition"] === true) {
                return diffClasses;
            }

            if (item["diff_comments"] === true) {
                return diffClasses;
            }

            return "comparison-item-diff-none";

        },

        loadPhotos () {
            if (this.item1) {
                this.fetchPhotos(this.item1);
            }

            if (this.item2) {
                this.fetchPhotos(this.item2);
            }
        },

        fetchPhotos (item) {
            axios.get("/inspections/items/" + item.id + "/photos")
            .then(response => {
                this.$set(item, "photos", response.data);
            });
        },

        /**
         * Check if the photo was copied from another
         * instance based on the origin uuid being defined
         */
        isCopiedPhoto (photo) {
            return photo.custom_properties && !_.isEmpty(photo.custom_properties.origin_uuid) && photo.custom_properties.origin_uuid !== photo.uuid;
        },

        closeComparisonItemPanel () {
            this.$emit("close-item-detail-panel");
        }
    }
};
</script>

<style scoped>

.comparison-line {
    vertical-align: top;
}

.comparison-line td {
    vertical-align: top;
}

.copied-photo {
    position: absolute;
    bottom: 0;
    right: 10px;
    color: #fff;
    font-size: 3em;
}

.checklist-item-photo-container-small {
    height: auto;
    width: 100%;
    margin: 2px 1px;
    position: relative;
    display: inline-block;
    page-break-inside: auto;
}

.checklist-item-photo-small {
    border-radius: 2px;
    height: auto;
    width: 100%;
}

</style>
